<template>
  <nxt-core-card :class="$setClasses"
                 :title="field.title"
                 icon="calendar-alt">
    <div
      v-if="field.content"
      :class="$vClass('content')"
      v-html="field.content">
    </div>
    <appointment-booking
      v-model="meeting"
      v-model:date-picker-date="datePickerDate"
      :calendar-options="$tm('meeting.calendarOptions')"
      :class="$vClass('booking')"
      :loading="meetingsSlotsLoading"
      :meetings-by-days="meetingsSlots"
      @datePickerDateChange="dateChange($event.date)"/>
    <meeting-display
      :class="$vClass('meeting')"
      :is-meeting-loading="meetingsSlotsLoading"
      :meeting="meeting"/>
  </nxt-core-card>
</template>

<script>
import { mapState, mapActions } from 'pinia';
import { usePartnerStore } from '../../../store/partnerStore.ts';
import { AppointmentBooking } from '@nextories/meeting-component';
import '@nextories/meeting-component/dist/lib/appointment-booking.css';

export default {
  name: 'Meeting',
  nameClassStyle: 'appointment',
  components: {
    AppointmentBooking,
  },
  props: {
    field: Object,
  },
  data() {
    return {
      datePickerDate: new Date(),
      meeting: null,
    };
  },
  computed: {
    ...mapState(usePartnerStore, ['duration', 'meetingsSlotsLoading', 'meetingsSlots']),
  },
  created() {
    this.dateChange(this.datePickerDate);
  },
  methods: {
    ...mapActions(usePartnerStore, ['getMeetingsSlots']),
    async dateChange(date) {
      try {
        Object.assign(this.field, { value: date });
        await this.getMeetingsSlots({
          days: 7,
          duration: this.duration,
          date: this.$helpers.format.formatDateWithTimezone(date),
        });
      } catch (error) {
        console.error(error);
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.#{$prefixName}appointment {
  font-size: var(--nxt-font-size-medium);

  &__content {
    margin: var(--nxt-space-large) 0;
  }
}
</style>
